<template>
  <v-navigation-drawer
    v-model="isOpen"
    :width="$isMobile ? '100%' : '50%'"
    right
    fixed
    :permanent="isOpen"
    hide-overlay
    class="z-index--100">
    <div class="ma-3">
      <div class="d-flex">
        <v-btn
          dark
          fab
          x-small
          outlined
          color="primary"
          class="mr-3"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="subtitle-1 primary--text">
          Orden: {{ data.order }}
        </div>
      </div>
      <div>
        <div
          v-if="loading"
          class="d-flex justify-center align-center">
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
        <div v-else>
          <div class="mb-4">
            <div
              class="py-3 primary--text font-weight-bold">
              Platillos:
            </div>
            <v-card>
              <v-data-table
                :items="data.details"
                :headers="[
                  { text: this.$i18n.t('Platillo'), value: 'dish', sortable: true },
                  { text: this.$i18n.t('Tipo'), value: 'onModel', sortable: false },
                  { text: this.$i18n.t('Cantidad vendida'), value: 'quantity', sortable: false },
                  { text: this.$i18n.t('Precio unitario'), value: 'unitPrice', sortable: false },
                  { text: this.$i18n.t('Total'), value: 'total', sortable: false }
                ]"
                hide-default-footer>
                <template v-slot:item.unitPrice="{ item }">
                  {{ item.unitPrice | toFixNumber(2) | numberWithComma | prefix('$') }}
                </template>
                <template v-slot:item.total="{ item }">
                  {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
                </template>
              </v-data-table>
            </v-card>
          </div>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  data () {
    return {
      isOpen: false,
      loading: false,
      data: {}
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    open (item) {
      this.isOpen = true
      this.data = item
    },
    close () {
      this.isOpen = false
    }
  }
}
</script>
